import * as yup from 'yup';

// src/helpers/validationSchemas/reports/inventoryOnHandReportSchema.ts
var inventoryOnHandReportSchema = yup.object().shape({
  name: yup.string().trim().required("nameRequired"),
  scheduleStartDateTime: yup.string().trim().when("isSchedulingEnabled", {
    is: true,
    then: (schema) => schema.required("scheduleStartDateTimeRequired").test(
      // test that is valid date
      "scheduleStartDateTimeRequired",
      "scheduleStartDateTimeRequired",
      (value) => {
        return !value || !isNaN(Date.parse(value));
      }
    ),
    otherwise: (schema) => schema.notRequired()
  }),
  recipients: yup.array().when("isSchedulingEnabled", {
    is: true,
    then: (schema) => schema.required("recipientsRequired").test("recipientsRequired", "recipientsRequired", (value) => {
      return value && value.length > 0;
    }),
    otherwise: (schema) => schema.notRequired()
  })
});

export { inventoryOnHandReportSchema };
